import React from 'react';
import '../Assets/Css/AttendanceDaysShowCard.scss';

function TicketCard({ title, value, icon }) {
    return (
        <div className="card">
            <div className="card-cont">
                <div className="card-title">{title}</div>
                <div className="card-value">{value}</div>
            </div>
            <div className="card-icon">
                <img src={icon} alt="Calendar" className='img rounded-circle' />
            </div>
        </div>
    );
}

export default TicketCard;